// Firestore collection names, shared by the app (config/firebase.js) and the
// web app (web/src/firebase.web.js). No imports, so both bundlers load it.
export const COLLECTIONS = {
  USERS: "users",
  USER_EMAILS: "user_emails",
  CLUBS: "clubs",
  EVENTS: "events",
  CLUB_MEMBERS: "club_members",
  CLUB_APPLICATIONS: "club_applications",
  EVENT_ATTENDEES: "event_attendees",
  NOTIFICATIONS: "notifications",
  CLUB_CHATS: "club_chats",
  CLUB_MESSAGES: "club_messages",
  CLUB_SUBCHATS: "club_subchats",
  CLUB_SUBCHAT_MESSAGES: "club_subchat_messages",
  EVENT_CHATS: "event_chats",
  EVENT_MESSAGES: "event_messages",
  CHAT_MEMBERS: "chat_members",
  EMAILS: "emails",
  EMAIL_VERIFICATIONS: "email_verifications",
  USER_NOTIFICATION_PREFERENCES: "user_notification_preferences",
  PUSH_TOKENS: "push_tokens",
  CLUBS_CATEGORIES: "clubs_categories",
  OTP_RATE_LIMITS: "otp_rate_limits",
  BUSINESSES: "businesses",
  BUSINESS_PROMOS: "promos",
  BUSINESS_PUBLIC_PROFILES: "business_public_profiles",
  // Messaging foundation (2026-10-11): blocks keyed `${blockerUid}_${blockedUid}`,
  // club_staff keyed `${clubId}_${uid}` (server-written), and DM / club-inbox
  // threads with a `messages` subcollection.
  USER_BLOCKS: "user_blocks",
  CLUB_STAFF: "club_staff",
  CONVERSATIONS: "conversations",
  CONVERSATION_MESSAGES: "messages",
  // Connect (2026-10-12): server-written pair docs keyed [uidA,uidB].sort().join("_")
  // and the server-written campus-wide public profile mirror.
  CONNECTIONS: "connections",
  USER_PUBLIC: "user_public",
};
